import { Table } from 'antd';
import React from 'react';

import type { BranchIndicatorsReportTableProps } from '@app/pages/Analytics/BranchIndicators/types';
import { transformBranchIndicatorsReportToTableData } from '@app/pages/Analytics/BranchIndicators/utils';

const HEADER_HEIGHT = 440;

export const BranchIndicatorsReportTable: React.FC<
  BranchIndicatorsReportTableProps
> = ({ isLoading, tableData }) => {
  const { dataSource, columns } =
    transformBranchIndicatorsReportToTableData(tableData);

  return (
    <Table
      bordered
      columns={columns}
      dataSource={dataSource}
      pagination={false}
      loading={isLoading}
      className="branch-indicators-report-table table-border-dark"
      rowClassName={(record) => {
        if (record.key === 'total') return 'table-total-row';
        return '';
      }}
      scroll={{ x: 'max-content', y: `calc(100vh - ${HEADER_HEIGHT}px)` }}
    />
  );
};
